module.exports = __webpack_public_path__ + "static/media/bb.980bd9cb.jpg";